import { useTranslation } from 'react-i18next';
import { errorMessages } from '../translations/errors';
import { ApiErrorResponse } from '../types/errors';
import { useCallback } from 'react';

export const useApiError = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language || 'en';

  const getErrorMessage = useCallback((error: ApiErrorResponse): string => {
    const messageKey = error.message;
    const messages = errorMessages[currentLanguage as keyof typeof errorMessages]?.errors;
    
    if (messages && messageKey in messages) {
      return messages[messageKey as keyof typeof messages];
    }

    return errorMessages.en.errors.unknown;
  }, [currentLanguage]);

  const handleError = useCallback((error: ApiErrorResponse): void => {
    const message = getErrorMessage(error);
    // You can use your preferred notification system here
    console.error(message);
    // Example: toast.error(message);
  }, [getErrorMessage]);

  return {
    getErrorMessage,
    handleError
  };
}; 